/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/destinationHelpers.ts (Queues)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Helper utilities for managing destination strings (module:destination).

────────────────────────────────────────────────────────────────*/

/**
 * Parse destination string (module:destination) into module and destination
 */
export function parseDestination(destination: string): { module: string; destination: string } {
  if (!destination || typeof destination !== 'string') {
    return { module: '', destination: '' };
  }
  const parts = destination.split(':');
  if (parts.length >= 2) {
    return { module: parts[0], destination: parts.slice(1).join(':') };
  }
  // If no colon, assume it's just a destination value (legacy format)
  return { module: '', destination };
}

/**
 * Combine module and destination into a string (module:destination)
 */
export function combineDestination(module: string, destination: string): string {
  if (!module && !destination) return '';
  if (!module) return destination;
  if (!destination) return '';
  return `${module}:${destination}`;
}

